import React from 'react';

import AssessmentContext from './context';

export const useAssessmentContext = () => {
  const context = React.useContext(AssessmentContext);
  if (context === undefined) {
    throw new Error('useAssessmentContext must be used within a AssessmentProvider');
  }
  return context;
};
